import { useQuery } from '@tanstack/react-query';
import { allocationQueries } from '../queries';
import type { UnallocatedFilters } from '../types/Checks';

export function useUnallocatedContracts(filters: UnallocatedFilters) {
  return useQuery(allocationQueries.unallocated(filters));
}
